export const CRM_SETTINGS_RESET_STATE = 'CRM_SETTINGS_RESET_STATE';
export const CRM_SETTINGS_CURRENT_ITEM = 'CRM_SETTINGS_CURRENT_ITEM';

export const CRM_SETTINGS_REQUEST_LOADING = 'CRM_SETTINGS_REQUEST_LOADING';
export const CRM_SETTINGS_REQUEST_SUCCESS = 'CRM_SETTINGS_REQUEST_SUCCESS';
export const CRM_SETTINGS_REQUEST_FAILED = 'CRM_SETTINGS_REQUEST_FAILED';

export const CRM_SETTINGS_CURRENT_ACTION = 'CRM_SETTINGS_CURRENT_ACTION';
export const CRM_SETTINGS_RESET_ACTION = 'CRM_SETTINGS_RESET_ACTION';
